import script from "./rankList.vue?vue&type=script&setup=true&lang=js"
export * from "./rankList.vue?vue&type=script&setup=true&lang=js"

import "./rankList.vue?vue&type=style&index=0&id=7228f2f4&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7228f2f4"]])

export default __exports__